var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import SlideImages from './SlideImages';
import SlideImagesLazy from './SlideImagesLazy';
var LocationSearch = /** @class */ (function (_super) {
    __extends(LocationSearch, _super);
    function LocationSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.locationForm = {
            finality: 1,
            city: null,
            uf: null,
            type: null,
            neighborhood: null,
            neighborhood_pt: null,
            bedroom: null,
            suites: null,
            vacancy: null,
            entrada: null,
            mensais: null,
            price: null,
            modalidade: null,
            "academia": null,
            "acessibilidade": null,
            "elevador": null,
            "gas-encanado": null,
            "piscina": null,
            "portaria": null,
            "churrasqueira-na-sacada": null,
            "vista-para-o-mar": null,
            "mobiliado": null,
        };
        _this.filter = false;
        _this.sort = '';
        _this.visible = false;
        return _this;
    }
    LocationSearch.prototype.beforeMount = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if ((_a = this.initialData) === null || _a === void 0 ? void 0 : _a.uf)
            this.locationForm.uf = this.initialData.uf;
        if ((_b = this.initialData) === null || _b === void 0 ? void 0 : _b.modalidade)
            this.locationForm.modalidade = this.initialData.modalidade;
        if ((_c = this.initialData) === null || _c === void 0 ? void 0 : _c.city)
            this.locationForm.city = this.initialData.city;
        if ((_d = this.initialData) === null || _d === void 0 ? void 0 : _d.neighborhood)
            this.locationForm.neighborhood = this.initialData.neighborhood;
        if ((_e = this.initialData) === null || _e === void 0 ? void 0 : _e.neighborhood_pt)
            this.locationForm.neighborhood_pt = this.initialData.neighborhood_pt;
        if ((_f = this.initialData) === null || _f === void 0 ? void 0 : _f.type) {
            if (this.initialData.type == 'cobertura') {
                this.locationForm.type = this.initialData.type;
            }
            else if (this.initialData.type == 'sobrado') {
                this.locationForm.type = this.initialData.type;
            }
            else if (this.initialData.type == 'kitinete') {
                this.locationForm.type = this.initialData.type;
            }
            else if (this.initialData.type == 'condominio') {
                this.locationForm.type = this.initialData.type;
            }
            else {
                this.locationForm.type = parseInt(this.initialData.type);
            }
        }
        if ((_g = this.initialData) === null || _g === void 0 ? void 0 : _g.bedroom)
            this.locationForm.bedroom = parseInt(this.initialData.bedroom);
        if ((_h = this.initialData) === null || _h === void 0 ? void 0 : _h.suites)
            this.locationForm.suites = parseInt(this.initialData.suites);
        if ((_j = this.initialData) === null || _j === void 0 ? void 0 : _j.vacancy)
            this.locationForm.vacancy = parseInt(this.initialData.vacancy);
        if ((_k = this.initialData) === null || _k === void 0 ? void 0 : _k.price)
            this.locationForm.price = this.initialData.price;
        if ((_l = this.initialData) === null || _l === void 0 ? void 0 : _l.entrada)
            this.locationForm.entrada = this.initialData.entrada;
        if ((_m = this.initialData) === null || _m === void 0 ? void 0 : _m.mensais)
            this.locationForm.mensais = this.initialData.mensais;
        if ((_o = this.initialData) === null || _o === void 0 ? void 0 : _o.sort)
            this.sort = this.initialData.sort;
    };
    LocationSearch.prototype.close = function () {
        this.visible = false;
    };
    LocationSearch.prototype.open = function () {
        this.visible = true;
    };
    LocationSearch.prototype.checkForm = function (e) {
        e.target.querySelectorAll("input").forEach(function (i) {
            if (i.value == '0' || !i.value) {
                i.disabled = true;
            }
        });
        // e.find('input').each(function() {
        //     var input = $(this);
        //     if (!input.val()) {
        //         input.remove(); // or input.prop('disabled', true);
        //     }
        // });
    };
    LocationSearch.prototype.selectedTab = function (tab) {
        this.tabSelected = tab;
    };
    LocationSearch.prototype.setFormToggle = function (name, value) {
        if (this.locationForm[name] == value) {
            this.locationForm[name] = null;
        }
        else {
            this.locationForm[name] = value;
        }
    };
    LocationSearch.prototype.clearFilters = function () {
        this.locationForm = {
            finality: 1,
            city: null,
            type: null,
            neighborhood: null,
            neighborhood_pt: null,
            bathroom: null,
            suites: null,
            vacancy: null,
        };
    };
    LocationSearch.prototype.openFilters = function () {
        this.filter = true;
    };
    LocationSearch.prototype.onSort = function () {
        setTimeout(function () {
            document.getElementById("form-search").submit();
        }, 1);
    };
    LocationSearch.prototype.closeFilter = function () {
        this.filter = false;
    };
    __decorate([
        Prop()
    ], LocationSearch.prototype, "initialData", void 0);
    __decorate([
        Prop({ default: 'general' })
    ], LocationSearch.prototype, "tabSelected", void 0);
    LocationSearch = __decorate([
        Component({
            components: {
                SlideImages: SlideImages,
                SlideImagesLazy: SlideImagesLazy
            },
        })
    ], LocationSearch);
    return LocationSearch;
}(Vue));
export default LocationSearch;
